import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { isTest } from '../config/envs';

import { createGrowthBookClient } from './lib/growthbook/client';
import { GrowthBookProvider } from './lib/growthbook/provider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      ...(isTest && { cacheTime: 0, retry: false }),
    },
  },
});

const growthbookClient = createGrowthBookClient();

growthbookClient.init();

export function AppProviders({ children }) {
  return (
    <GrowthBookProvider client={growthbookClient}>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </BrowserRouter>
    </GrowthBookProvider>
  );
}
